export const REMOVE_FILTER = 'REMOVE_FILTER';

export function removeFilter(filter) {
  return {
    type: REMOVE_FILTER,
    payload: filter,
  };
}
